import errorModalTemplate from './error_modal.html';

const BBServicesCtrl = function ($scope, $rootScope, $q, $attrs, $uibModal, BBWidget, BBModel, FormDataStoreService,  ErrorService, $filter, LoadingService, $translate, GeneralOptions, halClient) {
    'ngInject';
    this.$scope = $scope;

    /**
     * Look at ./v2/service.controller.js @ getServices() method
     * This function replicates the same behaviour and it is meant to be temporary!
     */
    function getServicesExcludingChildServicesLinks() {
        let apiUrl = `${$scope.bb.api_url}/api/v1`;
        if (BBWidget.isAdmin) {
            apiUrl += '/admin';
        }

        const servicesUrl = `${apiUrl}/${$scope.bb.company.id}/services/?exclude_links[]=child_services`;

        return halClient.$get(servicesUrl)
            .then(serviceResource => serviceResource.$get('services'))
            .then((services) => {
                return services.map(s => new BBModel.Service(s));
            });
    }

    FormDataStoreService.init('ServiceList', $scope, [
        'service'
    ]);

    const loader = LoadingService.$loader($scope).notLoaded();

    $scope.filters = {
        category_name: null,
        service_name: null,
        price: {
            min: 0,
            max: 100
        },
        custom_array_value: null
    };
    $scope.show_custom_array = false;

    $scope.options = $scope.$eval($attrs.bbServices) || {};

    if ($attrs.bbItem) {
        $scope.booking_item = $scope.$eval($attrs.bbItem);
    }
    if ($attrs.bbShowAll || $scope.options.show_all) {
        $scope.show_all = true;
    }
    if ($scope.options.allow_single_pick) {
        $scope.allowSinglePick = true;
    }
    if ($scope.options.hide_disabled) {
        $scope.hide_disabled = true;
    }

    $scope.price_options = {
        min: 0,
        max: 100
    };

    $scope.$on('services:refreshList', () => {
        loader.notLoaded();
        $scope.init($scope.bb.company);
    });

    $rootScope.connection_started.then(() => {
        if ($scope.bb.company) {
            return $scope.init($scope.bb.company);
        }
    }, err => loader.setLoadedAndShowError($scope, err, 'Sorry, something went wrong'));

    $scope.init = function (comp) {
        let item;
        if (!$scope.booking_item) {
            $scope.booking_item = $scope.bb.current_item;
        }

        if ($scope.bb.company.$has('named_categories')) {
            BBModel.Category.$query($scope.bb.company).then((items) => {
                return $scope.all_categories = items;
            }, err => $scope.all_categories = []);
        } else {
            $scope.all_categories = [];
        }

        // check any curretn service is valid for the current company
        if ($scope.service && ($scope.service.company_id !== $scope.bb.company.id)) {
            $scope.service = null;
        }

        // TODO: restore this. See => https://github.com/BookingBug/bookingbug-angular/pull/1485
        //let gettingServiceData = comp.$getServices();
        let gettingServiceData = getServicesExcludingChildServicesLinks();


        gettingServiceData.then((items) => {

            if ($scope.options.hide_disabled) {
                // this might happen to ahve been an admin api call which would include disabled services - and we migth to hide them
                items = items.filter(x => !x.disabled && !x.deleted);
            }

            // not all service lists need filtering. check for attribute first
            const filterItems = $attrs.filterServices === 'false' ? false : true;

            if (filterItems) {
                if ($scope.booking_item.service_ref && !$scope.options.show_all) {
                    items = items.filter(x => x.api_ref === $scope.booking_item.service_ref);
                } else if ($scope.booking_item.category && !$scope.options.show_all) {
                    // if we've selected a category for the current item - limit the list
                    // of services to ones that are relevant
                    items = items.filter(x => x.$has('category') && (x.$href('category') === $scope.booking_item.category.self));
                }
            }

            // filter out event groups unless explicity requested
            if (!$scope.options.show_event_groups) {
                items = items.filter(x => !x.is_event_group);
            }

            // if there's only one service and single pick hasn't been enabled,
            // automatically select the service.
            if ((items.length === 1) && !$scope.options.allow_single_pick) {
                if (!$scope.selectItem(items[0], $scope.nextRoute, {
                        skip_step: true
                    })) {
                    setServiceItem(items);
                }
            } else {
                setServiceItem(items);
            }

            // if there's a default - pick it and move on
            if ($scope.booking_item.defaultService()) {
                for (item of Array.from(items)) {
                    if ((item.self === $scope.booking_item.defaultService().self) || ((item.name === $scope.booking_item.defaultService().name) && !item.deleted)) {
                        $scope.selectItem(item, $scope.nextRoute, {
                            skip_step: true
                        });
                    }
                }
            }

            // if there's one selected - just select it
            if ($scope.booking_item.service) {
                for (item of Array.from(items)) {
                    item.selected = false;
                    if (item.self === $scope.booking_item.service.self) {
                        $scope.service = item;


                        /**
                         * If the moving_booking field is populated, means we are moving a
                         * booking (you don't say?), so we can flag the service itself as
                         * being moved.
                         *
                         * see basket_item_model.service#setService
                         *
                         */
                        $scope.service.isBeingMoved = BBWidget.moving_booking !== undefined;
                        item.selected = true;

                        $scope.booking_item.setService($scope.service);
                    }
                }
            }

            if ($scope.booking_item.service || !(($scope.booking_item.person && !$scope.booking_item.anyPerson()) || ($scope.booking_item.resource && !$scope.booking_item.anyResource()))) {
                // the "bookable services" are the service unless we've pre-selected something!
                items = setServicesDisplayName(items);
                return $scope.bookable_services = items;
            }
        });

        if (($scope.booking_item.person && !$scope.booking_item.anyPerson()) || ($scope.booking_item.resource && !$scope.booking_item.anyResource()) || GeneralOptions.disableUnbookableServices) {
            // If we've already picked a service or a resource - get a more limited service selection.

            // Adding new get bookable items promise into the chain if condition was met.
            gettingServiceData = gettingServiceData
                .then(() => {
                    return BBModel.BookableItem.$query({
                        company: $scope.bb.company,
                        cItem: $scope.booking_item,
                        item: 'service'
                    });
                })
                .then((items) => {
                    if ($scope.booking_item.service_ref) {
                        items = items.filter(x => x.api_ref === $scope.booking_item.service_ref);
                    }

                    if ($scope.booking_item.group) {
                        items = items.filter(x => !x.group_id || (x.group_id === $scope.booking_item.group));
                    }

                    if ($scope.options.hide_disabled) {
                        // This might happen to have been an admin api call which would include disabled services.
                        // We might want to hide them.
                        items = items.filter(x => (x.item === null) || (!x.item.disabled && !x.item.deleted));
                    }

                    let services = (Array.from(items).filter(i => (i.item !== null)).map(i => i.item));

                    // It might be configured to disable services that are not bookable.
                    if (GeneralOptions.disableUnbookableServices) {
                        $scope.filtered_items.forEach((service) => {
                            // Disable all services that cannot be find in bookable items.
                            service.disabled = !services.some(bookableService => bookableService.id === service.id);

                            // Add cause of exclusion to service name.
                            if (service.disabled) {
                                service.displayName = service.name.concat(' ').concat(
                                    $translate.instant('PUBLIC_BOOKING.SERVICE_LIST.NO_STAFF_FOR_SERVICE', {
                                        companyName: $scope.company.name
                                    }));
                            } else {
                                // Using new display name not to override original service name.
                                service.displayName = service.name;
                            }
                        });
                    } else {
                        services = setServicesDisplayName(services);

                        $scope.bookable_services = services;

                        $scope.bookable_items = items;

                        if ((services.length === 1) && !$scope.options.allow_single_pick) {
                            if (!$scope.selectItem(services[0], $scope.nextRoute, {
                                    skip_step: true
                                })) {
                                return setServiceItem(services);
                            }
                        } else {
                            // The ServiceModel is more relevant than the BookableItem when price and duration needs to be listed in the view pages.
                            return setServiceItem(services);
                        }
                    }
                });
        }

        return gettingServiceData
            .then(() => loader.setLoaded())
            .catch(error => loader.setLoadedAndShowError($scope, error, 'Sorry, something went wrong'));
    };


    const setServicesDisplayName = function (items) {
        for (const item of Array.from(items)) {
            if (item.disabled) {
                item.display_name = `${item.displayName} (${$translate.instant('PUBLIC_BOOKING.SERVICE_LIST.DISABLED')})`;
                item.name = `${item.name} (${$translate.instant('PUBLIC_BOOKING.SERVICE_LIST.DISABLED')})`;
            }
            if (item.listed_durations && (item.listed_durations.length === 1)) {
                item.display_name = item.name + ' - ' + $filter('time_period')(item.duration);
            } else {
                item.display_name = item.name;
            }
        }

        return items;
    };


    // set the service item so the correct item is displayed in the dropdown menu.
    // without doing this the menu will default to 'please select'
    const setServiceItem = function (items) {
        $scope.items = items;
        $scope.filtered_items = $scope.items;
        if ($scope.service) {
            return _.each(items, (item) => {
                if (item.id === $scope.service.id) {
                    return $scope.service = item;
                }
            });
        }
    };


    /***
     * @ngdoc method
     * @name selectItem
     * @methodOf BB.bbServices
     * @description
     * Select an item into the current booking journey and route on to the next page dpending on the current page control
     *
     * @param {object} item The Service or BookableItem to select
     * @param {string=} route A specific route to load
     */
    $scope.selectItem = (item, route, options) => {

        if (options == null) {
            options = {};
        }
        if ($scope.routed) {
            return true;
        }

        if ($scope.$parent.$has_page_control) {
            $scope.service = item;
            return false;
        } else if (item.is_event_group) {
            $scope.booking_item.setEventGroup(item);
            if (options.skip_step) {
                $scope.skipThisStep();
            }
            $scope.decideNextPage(route);
            return $scope.routed = true;
        } else {

            // Same logic from above for moving booking
            item.isBeingMoved = BBWidget.moving_booking !== undefined;
            $scope.booking_item.setService(item);


            // -----------------------------------------------------------
            // Only set bb.selected_service if the service is a parent service
            if (!$scope.booking_item.service.child_level_service) $scope.bb.selected_service = $scope.booking_item.service;
            // -----------------------------------------------------------
            if (options.skip_step) {
                $scope.skipThisStep();
            }
            $scope.decideNextPage(route);
            $scope.routed = true;
            return true;
        }
    };

    $scope.$watch('service', (newval, oldval) => {
        if ($scope.service && $scope.booking_item) {
            if (!$scope.booking_item.service || ($scope.booking_item.service.self !== $scope.service.self)) {
                // only set and broadcast if it's changed
                $scope.booking_item.setService($scope.service);
                $scope.broadcastItemUpdate();
                // -----------------------------------------------------------
                // Only set bb.selected_service if the service is a parent service
                if (!$scope.service.child_level_service) $scope.bb.selected_service = $scope.service;
                // -----------------------------------------------------------
                return;
            }
        }
    });

    /***
     * @ngdoc method
     * @name setReady
     * @methodOf BB.bbServices
     * @description
     * Set this page section as ready - see {@link BB:bbPage Page Control}
     */
    $scope.setReady = () => {
        if ($scope.service) {
            $scope.booking_item.setService($scope.service);
            return true;
        } else if ($scope.bb.stacked_items && ($scope.bb.stacked_items.length > 0)) {
            return true;
        } else {
            return false;
        }
    };

    /***
     * @ngdoc method
     * @name errorModal
     * @methodOf BB.bbServices
     * @description
     * Display error message in modal
     */
    $scope.errorModal = function () {
        return $uibModal.open({
            templateUrl: errorModalTemplate.id,
            controller($scope, $uibModalInstance) {
                $scope.message = ErrorService.getError('GENERIC').msg;
                return $scope.ok = () => $uibModalInstance.close();
            }
        });
    };

    /***
     * @ngdoc method
     * @name filterFunction
     * @methodOf BB.bbServices
     * @description
     * Filter service
     */
    $scope.filterFunction = function (service) {
        if (!service) {
            return false;
        }
        $scope.service_array = [];
        $scope.custom_array = function (match) {
            if (!match) {
                return false;
            }
            if ($scope.options.custom_filter) {
                match = match.toLowerCase();
                for (let item of Array.from(service.extra[$scope.options.custom_filter])) {
                    item = item.toLowerCase();
                    if (item === match) {
                        $scope.show_custom_array = true;
                        return true;
                    }
                }
                return false;
            }
        };
        $scope.service_name_include = function (match) {
            if (!match) {
                return false;
            }
            if (match) {
                match = match.toLowerCase();
                const item = service.name.toLowerCase();
                if (item.includes(match)) {
                    return true;
                } else {
                    return false;
                }
            }
        };
        return (!$scope.filters.category_name || (service.category_id === $scope.filters.category_name.id)) &&
            (!$scope.filters.service_name || $scope.service_name_include($scope.filters.service_name)) &&
            (!$scope.filters.custom_array_value || $scope.custom_array($scope.filters.custom_array_value)) &&
            (!service.price || ((service.price >= ($scope.filters.price.min * 100)) && (service.price <= ($scope.filters.price.max * 100))));
    };

    /***
     * @ngdoc method
     * @name resetFilters
     * @methodOf BB.bbServices
     * @description
     * Clear the filters
     */
    $scope.resetFilters = function () {
        if ($scope.options.clear_results) {
            $scope.show_custom_array = false;
        }
        $scope.filters.category_name = null;
        $scope.filters.service_name = null;
        $scope.filters.price.min = 0;
        $scope.filters.price.max = 100;
        $scope.filters.custom_array_value = null;
        return $scope.filterChanged();
    };

    /***
     * @ngdoc method
     * @name filterChanged
     * @methodOf BB.bbServices
     * @description
     * Filter changed
     */
    $scope.filterChanged = () => $scope.filtered_items = $filter('filter')($scope.items, $scope.filterFunction);

};

angular.module('BBPublicBooking').controller('BBServicesCtrl', BBServicesCtrl);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/services/bb_services.controller.js